import React, { useState, useEffect } from "react";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Carousel } from "react-responsive-carousel";
import Slide1 from "../../assets/70.jpg";
import Slide2 from "../../assets/startseitenslider02.jpg";
import Slide3 from "../../assets/67.jpg";
import Slide4 from "../../assets/62.jpg";
import Slide5 from "../../assets/great-people_2.jpg";
import Siegel from "../../assets/siegel2025.png";
import KaBoxRow from "../shared/KaBoxRow";
import KaBox from "../shared/KaBox";
import HomeIhreErwartungen from "./HomeIhreErwartungen";
import { useHistory } from "react-router-dom";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import HomeUnsereErwartungen from "./HomeUnsereErwartungen";
import HomeGemeinsamerWeg from "./HomeGemeinsamerWeg";
import useScreensize from "../../hooks/useScreensize";
import KaSiegel from "../shared/KaSiegel";

const useStyles = makeStyles(theme => ({
  sliderOuterWrapper: {
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2)
    }
  },
  sliderWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "52%"
  },
  sliderInner: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    "& > div": {
      position: "absolute",
      width: "100%",
      height: "100%"
    },
    "& .carousel": {
      height: "100%"
    },
    "& .carousel .slider-wrapper": {
      height: "100%"
    },
    "& .carousel .slider": {
      height: "100%"
    },
    "& .carousel .slide": {
      height: "100%"
    }
  },
  siegel: {
    position: "absolute",
    right: theme.spacing(4),
    top: "10%",
    height: "80%",
    width: "100%",
    backgroundImage: "url(" + Siegel + ")",
    backgroundSize: "auto 100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right center",
    cursor: "pointer",
  },
  slide: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    overflow: "hidden"
  },
  slideLink: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  },
  btnPrev: {
    position: "absolute",
    left: theme.spacing(0.5),
    top: "50%",
    marginTop: -15,
    color: "white",
    padding: 0
  },
  btnNext: {
    position: "absolute",
    right: theme.spacing(0.5),
    top: "50%",
    marginTop: -15,
    color: "white",
    padding: 0
  },
  btnSliderIcon: {
    width: 50,
    height: 50
  }
}));
const sliderImages = [
  { image: Slide1, showSiegel: true },
  { image: Slide2, showSiegel: false },
  { image: Slide3, showSiegel: false },
  { image: Slide4, showSiegel: false },
  { image: Slide5, showSiegel: false, link: "/kanzlei/karriere" }
];

const testColors = ["#eee", "#eee", "#ccc"];

const Home = ({ match }) => {
  const classes = useStyles();
  const [currentDialog, setCurrentDialog] = useState(null);
  const [closed, setClosed] = useState(false);
  const [showSiegel, setShowSiegel] = useState(false);
  const dispatch = useDispatch();
  const currentSlideIndex = useSelector(state => state.slider.currentIndex);
  const { xs } = useScreensize();
  const history = useHistory();

  useEffect(() => {
    if (!match.params.dialog) {
      setClosed(false);
    }
    setCurrentDialog(match.params.dialog || null);
  }, [match.params.dialog]);


  const onPrev = () => {
    dispatch({ type: "SET_PREV_SLIDE" });
  };

  const onNext = () => {
    dispatch({ type: "SET_NEXT_SLIDE" });
  };

  const onUpdateSlider = event => {
    // console.log(event);
  };

  if (closed) {
    setTimeout(() => {
      history.push("/");
    }, 100);
    // return <Redirect to="/" push />;
  }

  let calculatedSlideIndex = currentSlideIndex % sliderImages.length;
  if (calculatedSlideIndex < 0) {
    calculatedSlideIndex = sliderImages.length + calculatedSlideIndex;
  }

  return (
    <>
      <div className={classes.sliderOuterWrapper}>
        <div className={classes.sliderWrapper}>
          <div className={classes.sliderInner}>
          <Carousel
            autoPlay={!match.params.dialog}
            selectedItem={calculatedSlideIndex}
            onChange={onUpdateSlider}
            infiniteLoop
            showArrows={false}
            showThumbs={false}
            swipeable={true}
            showStatus={false}
            interval={5000}
          >
            {sliderImages.map((item, index) => (
              <div
                key={index}
                className={classes.slide}
                style={{
                  backgroundColor: testColors[index],
                  backgroundImage: "url(" + item.image + ")",
                  height: "100%"
                }}
              >
                {item.link && <a href={item.link} className={classes.slideLink}></a>}
                {item.showSiegel && <div onClick={() => setShowSiegel(true)} className={classes.siegel} />}
              </div>
            ))}
          </Carousel>
          {!xs && (
            <>
              <IconButton className={classes.btnPrev} onClick={onPrev}>
                <ChevronLeftIcon className={classes.btnSliderIcon} />
              </IconButton>
              <IconButton className={classes.btnNext} onClick={onNext}>
                <ChevronRightIcon className={classes.btnSliderIcon} />
              </IconButton>
            </>
          )}
          </div>
        </div>
      </div>
      <KaBoxRow last>
        <KaBox
          subtitle="Ihre"
          title="Erwartungen"
          to="/home/ihre-erwartungen"
        ></KaBox>
        <KaBox
          subtitle="Unsere"
          title="Erwartungen"
          to="/home/unsere-erwartungen"
        ></KaBox>
        <KaBox
          subtitle="Gemeinsamer"
          title="Weg"
          to="/home/gemeinsamer-weg"
          last
        ></KaBox>
      </KaBoxRow>
      <HomeIhreErwartungen
        open={currentDialog === "ihre-erwartungen"}
        close={() => {
          setClosed(true);
        }}
      />
      <HomeUnsereErwartungen
        open={currentDialog === "unsere-erwartungen"}
        close={() => {
          setClosed(true);
        }}
      />
      <HomeGemeinsamerWeg
        open={currentDialog === "gemeinsamer-weg"}
        close={() => {
          setClosed(true);
        }}
      />
      <KaSiegel
        open={showSiegel}
        close={() => setShowSiegel(false)}
      />
    </>
  );
};

export default Home;
